import { AnyAction, Dispatch, ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export type AppDispatch = Dispatch & ThunkDispatch<unknown, unknown, AnyAction>;

// as long as we do not have a fully typed store, it is not possible to type the getState function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GetStateFn<T = any> = () => T;
